import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from "@angular/core";

@Component({
  selector: "bca-page-header",
  templateUrl: "page-header.component.html",
  styleUrls: ["page-header.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PageHeaderComponent {
  @Input() isSubsequentCard = false;
  @Output() mijnNsZakelijkClick = new EventEmitter<void>();
}
